// export const baseURL = "http://192.168.4.246:8000/"
// export const baseURL = "http://redcrm.test/"
export const baseURL = "https://api.crmred.cl/"
// export const baseURL = "http://127.0.0.1:8000/"
//export const baseURL = "https://redcrm.local/"
export const settings = {
  some: 'Settings'
}
